export let api_urls;

if (window.location.protocol === 'http:') {
    api_urls = 'https://api.bharatdarshan.app/'
} else if (window.location.protocol === 'https:') {
    api_urls = 'https://api.bharatdarshan.app/'
} else {
    console.log('Unknown protocol');
}
